import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';

const TermsOfService: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom align="center">
          Terms of Service
        </Typography>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom>
            1. Acceptance of Terms
          </Typography>
          <Typography paragraph>
            By accessing and using transfersnews.org, you accept and agree to be bound by the terms
            and provision of this agreement. If you do not agree to abide by the above, please do
            not use this website.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom>
            2. Use License
          </Typography>
          <Typography paragraph>
            Permission is granted to temporarily download one copy of the materials (information or software)
            on transfersnews.org's website for personal, non-commercial transitory viewing only.
          </Typography>
          <Typography paragraph>
            This is the grant of a license, not a transfer of title, and under this license you may not:
          </Typography>
          <Typography component="div" sx={{ pl: 2 }}>
            • Modify or copy the materials
            <br />
            • Use the materials for any commercial purpose
            <br />
            • Attempt to decompile or reverse engineer any software contained on the website
            <br />
            • Remove any copyright or other proprietary notations from the materials
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom>
            3. User Content
          </Typography>
          <Typography paragraph>
            Users may post content as long as it isn't illegal, obscene, threatening, defamatory,
            invasive of privacy, infringing of intellectual property rights, or otherwise injurious
            to third parties.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom>
            4. Disclaimer
          </Typography>
          <Typography paragraph>
            The materials on transfersnews.org's website are provided on an 'as is' basis.
            transfersnews.org makes no warranties, expressed or implied, and hereby disclaims
            and negates all other warranties including, without limitation, implied warranties
            or conditions of merchantability, fitness for a particular purpose, or non-infringement
            of intellectual property or other violation of rights.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom>
            5. Limitations
          </Typography>
          <Typography paragraph>
            In no event shall transfersnews.org or its suppliers be liable for any damages
            (including, without limitation, damages for loss of data or profit, or due to business
            interruption) arising out of the use or inability to use the materials on transfersnews.org's website.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom>
            6. Accuracy of Materials
          </Typography>
          <Typography paragraph>
            The materials appearing on transfersnews.org's website could include technical,
            typographical, or photographic errors. transfersnews.org does not warrant that any
            of the materials on its website are accurate, complete, or current.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom>
            7. Links
          </Typography>
          <Typography paragraph>
            transfersnews.org has not reviewed all of the sites linked to its website and is
            not responsible for the contents of any such linked site. The inclusion of any link
            does not imply endorsement by transfersnews.org of the site.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom>
            8. Modifications
          </Typography>
          <Typography paragraph>
            transfersnews.org may revise these terms of service for its website at any time
            without notice. By using this website you are agreeing to be bound by the then
            current version of these terms of service.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom>
            9. Governing Law
          </Typography>
          <Typography paragraph>
            These terms and conditions are governed by and construed in accordance with the laws
            and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom>
            10. Contact Information
          </Typography>
          <Typography paragraph>
            If you have any questions about these Terms of Service, please contact us at:
            terms@transfersnews.org
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default TermsOfService; 